import React from 'react';
import { ICheckBoxProps } from './Checkbox.model';

const CheckBox = (props: ICheckBoxProps) => {
    const { checked, onChange, name, label } = props;
    return (
        <div className="custom-control custom-checkbox custom-control-inline">
            <input
                type="checkbox"
                className="custom-control-input"
                id={name}
                checked={checked}
                onChange={onChange}
            />
            <label
                className="custom-control-label"
                htmlFor={name}
            >
                {label}
            </label>
        </div>
    )
}

export default CheckBox;
